
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface VolumeMultiplierFieldProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export const VolumeMultiplierField: React.FC<VolumeMultiplierFieldProps> = ({ 
  form,
  disabled = false
}) => {
  const { t } = useTranslation();
  
  return (
    <FormField
      control={form.control}
      name="volume_multiplier"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('volume_multiplier')}</FormLabel>
          <FormControl>
            <Input 
              type="number" 
              placeholder={t('enter_volume_multiplier')} 
              {...field} 
              min="0.1" 
              step="0.1"
              disabled={disabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
